import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import JobListings from './UserData';
import Config from './Config/config';



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/api/iframe" element={<JobListings />} />
        <Route path="/api/iframe/job" element={<JobListings />} />
       
        {/* <Route path='/config' element={<Config/>}/> */}
       
      </Routes>
    </Router>
  );
}

export default App;